import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "idSingleSelect",
    standalone: false
})
export class IdSingleSelectPipe implements PipeTransform {
  transform(items: any[], ownId: number, selected: any[], identifier?: string): any[] {
    if (!items) return [];

    return items.filter((it) => {
      if (it.id === ownId) {
        return true;
      }
      return !selected.some((sel) => {
        if (identifier) {
          return sel[identifier] === it.id;
        }
        return sel.id === it.id;
      });
    });
  }
}
